<div class="container">
  <app-drawer-workorder-title
    title="{{ drawerTitle }}"
    [externalId]="workOrder.externalId"
    [clientName]="workOrder.clientName"
  ></app-drawer-workorder-title>

  <div class="content">
    <p *ngIf="validateWorkOrder">
      {{ "workorder.reject-validate.validate-description" | translate }}
    </p>
    <p *ngIf="!validateWorkOrder">
      {{ "workorder.reject-validate.reject-description" | translate }}
    </p>
    <p *ngIf="validateWorkOrder">
      {{ "workorder.reject-validate.validate-question" | translate }}
    </p>
    <p *ngIf="!validateWorkOrder">
      {{ "workorder.reject-validate.reject-question" | translate }}
    </p>
  </div>

  <app-drawer-workorder-actions
    confirmButtonName="{{ 'workorder.reject-validate.yes' | translate }}"
    (clickConfirmButtonEvent)="
      validateWorkOrder ? confirmWorkOrder() : rejectWorkOrder()
    "
    [confirmButtonIsEnable]="saveButtonIsEnable"
    (clickCancelButtonEvent)="close()"
  ></app-drawer-workorder-actions>
</div>
